// extracted by mini-css-extract-plugin
export default {"box":"CTA_box__LPgWl","title":"CTA_title__32QXd","accent":"CTA_accent__Ss6vq"};